import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import cx from "classnames";

import styles from "./MarketingBlock.module.scss";
import desktopImg from "../assets/img/2605_Ecom_Portal_MarketingBlock_Pods_Coconut_Desktop.webp";
import mobileImg from "../assets/img/2605_Ecom_Portal_MarketingBlock_Pods_Coconut_Mobile.webp";
import { getSubscriptions } from "./subscriptions/actions";
import { useDispatch } from "react-redux";

function MarketingBlock() {
    const dispatch = useDispatch();
    const history = useHistory();

    const [subscription, setSubscription] = useState();

    useEffect(() => {
        const loadData = async () => {
            try {
                const data = await dispatch(getSubscriptions());
                setSubscription(data.data.length);
            } catch (error) {
                console.error("Failed to fetch:", error);
            }
        };
        loadData();
    }, [dispatch, setSubscription, subscription]);

    function handleClick() {
        history.push("/subscriptions");
    }

    if (subscription > 0) {
        return (
            <section className={cx(styles.marketingBlock)}>
                <div className={cx(styles.content)}>
                    <h3>A trip to the tropics ?</h3>
                    <p>Try our coconut pods and you'll basically be there.</p>
                    <button onClick={handleClick}>Swap your blends</button>
                </div>

                <picture className={cx(styles.image)}>
                    <source media="(min-width: 768px)" srcSet={desktopImg} />
                    <img src={mobileImg} alt="flavor-img" />
                </picture>
            </section>
        );
    }
}

export default MarketingBlock;
